import script from "./HistoryFinances.vue?vue&type=script&lang=ts&setup=true"
export * from "./HistoryFinances.vue?vue&type=script&lang=ts&setup=true"

import "./HistoryFinances.vue?vue&type=style&index=0&id=5b098ca8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b098ca8"]])

export default __exports__